import { AnimatePresence } from 'framer-motion'
import React, { Suspense, memo } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import router, { ignorePath, routerType } from './conf'
const modules = import.meta.glob('../pages/**/*')

export const routerAnimate = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: {
    duration: 0.15,
    type: 'spring',
    damping: 35,
    stiffness: 600
  }
}

// 守卫
const RequireAuth = ({ component }: { component: string }) => {
  const location = useLocation()
  console.info('页面：', location.pathname, location)
  const userid = localStorage.getItem('userid') || false
  // 注意，如果路由中没有「/」的声明，一定要排除，不然Navigate受两次跳转会失效
  if (!ignorePath.includes(location.pathname) && !userid) {
    localStorage.clear()
    return <Navigate to="/" state={{ from: location }} replace />
  } else {
    const Compontents = React.lazy(modules[component] as any)
    return (
      <Suspense>
        <AnimatePresence
          mode="wait"
          initial={true}
          onExitComplete={() => {
            if (typeof window !== 'undefined') {
              window.scrollTo({ top: 0 })
            }
          }}
        >
          <Compontents key={location.pathname} />
        </AnimatePresence>
      </Suspense>
    )
  }
}

// 循环
const RouterTree = (tree: routerType[]) => {
  return tree.map(({ path, component, children }) => {
    if (children && children.length) {
      return (
        <Route key={path} path={path} element={component}>
          {RouterTree(children)}
        </Route>
      )
    } else {
      return <Route key={path} path={path} element={<RequireAuth component={component as string}></RequireAuth>} />
    }
  })
}

// 动画
export const AnimatedRoutes = memo(() => {
  // const location = useLocation()
  // console.log(location)
  return (
    // <AnimatePresence
    //   mode="wait"
    //   initial={true}
    //   onExitComplete={() => {
    //     if (typeof window !== 'undefined') {
    //       window.scrollTo({ top: 0 })
    //     }
    //   }}
    // >
    <Routes>{RouterTree(router)}</Routes>
    // </AnimatePresence>
  )
})
